export default __webpack_public_path__ + "static/media/PAM.63941cf7.webp";